import {
	BACKUP_SERVICES_DEV_CONFIG,
	BACKUP_SERVICES_PROD_CONFIG,
	BROADCAST_SOCKET_DEV_CONFIG,
	BROADCAST_SOCKET_PROD_CONFIG,
	SPORTSX_CONFIG
} from "_services/firebase/projectConfig";

const SCOREBOARD_SOCKET_CONFIG = {
	apiKey            : "AIzaSyDQeVkxAgxtwcKzX2sVEQl6Z4nfVRPr1BY",
	authDomain        : "scoreboard-api-mumbai.firebaseapp.com",
	databaseURL       : "https://scoreboard-api-mumbai.firebaseio.com",
	projectId         : "scoreboard-api-mumbai",
	storageBucket     : "scoreboard-api-mumbai.appspot.com",
	messagingSenderId : "813907988045"
};

const WEB_CONFIG = {
	apiKey            : "AIzaSyDH7_9UFZ346h-gdt9qaaKPkW6hw6xQqnc",
	authDomain        : "web-firebase-add4b.firebaseapp.com",
	databaseURL       : "https://web-firebase-add4b.firebaseio.com",
	projectId         : "web-firebase-add4b",
	storageBucket     : "web-firebase-add4b.appspot.com",
	messagingSenderId : "724498387292",
	appId             : "1:724498387292:web:6a82749cd9b2da2cb03199",
	measurementId     : "G-XHLEY8995X"
};

const env = process.env.APP_ENV || "dev";

const config = {
	dev: {
		FEED_API                  : "https://dev-consumer-feed.rooter.io/graphql",
		BROADCAST_VIEWS           : "https://stage-broadcast-view-events.rooter.io/broadcastViewEvents",
		BASE_URL                  : "https://final.api.rooter.io/v3/",
		USER_API_URL              : "https://dev-user.api.rooter.io/",
		APP_SECRET_KEY            : "@5p0rt5xakar00t3r2019clientwebtoserver@",
		FIREBASE_CONFIG           : SCOREBOARD_SOCKET_CONFIG,
		FIREBASE_BROADCAST_CONFIG : BROADCAST_SOCKET_DEV_CONFIG,
		FIREBASE_WEB_CONFIG       : WEB_CONFIG,
		FIREBASE_SPORTSX_CONFIG   : SPORTSX_CONFIG,
		FIREBASE_BACKUP_CONFIG    : BACKUP_SERVICES_DEV_CONFIG,
		REDIRECT                  : "https://dev-mobile.rooter.io/",
		CONSUMER_FEED_URL         : "https://dev-consumer-feed.rooter.io/",
		FEED_POPULATOR_URL        : "https://dev-feed.rooter.io/",
		APPOLLO_URL               : "https://dev-consumer-feed.rooter.io/graphql",
		BROADCAST_URL             : "https://dev-broadcast.rooter.io/data",
		BROADCAST_DNS             : "https://dev-broadcast.rooter.io/",
		GROOT_URL                 : "https://dev-groot.rooter.io/",
		GA_ID                     : "UA-105786949-15",
		SEARCH_URL                : "https://search.rooter.io/",
		firebase                  : {
			broadcast       : BROADCAST_SOCKET_DEV_CONFIG,
			sportx          : SPORTSX_CONFIG,
			backup_services : BACKUP_SERVICES_DEV_CONFIG
		}
	},
	stage: {
		FEED_API                  : "https://stage-feed.rooter.io/graphql",
		BROADCAST_VIEWS           : "https://stage-broadcast-view-events.rooter.io/broadcastViewEvents",
		BASE_URL                  : "https://semi-final.api.rooter.io/v3/",
		USER_API_URL              : "https://semi-final.api.rooter.io/",
		APP_SECRET_KEY            : "280947ca35f58f88d517efba13e1a61501fd68a0822d48525e22d2215521e7bd",
		FIREBASE_CONFIG           : SCOREBOARD_SOCKET_CONFIG,
		FIREBASE_BROADCAST_CONFIG : BROADCAST_SOCKET_PROD_CONFIG,
		FIREBASE_WEB_CONFIG       : WEB_CONFIG,
		FIREBASE_SPORTSX_CONFIG   : SPORTSX_CONFIG,
		FIREBASE_BACKUP_CONFIG    : BACKUP_SERVICES_PROD_CONFIG,
		REDIRECT                  : "https://stage-mobile.rooter.io/",
		CONSUMER_FEED_URL         : "https://stage-feed.rooter.io/",
		FEED_POPULATOR_URL        : "https://feed-populator.rooter.io/",
		APPOLLO_URL               : "https://stage-feed.rooter.io/graphql",
		BROADCAST_URL             : "https://stage-broadcast.rooter.io/data",
		BROADCAST_DNS             : "https://stage-broadcast.rooter.io/",
		GROOT_URL                 : "https://stage-groot.rooter.io/",
		GA_ID                     : "UA-105786949-15",
		SEARCH_URL                : "https://search.rooter.io/",
		firebase                  : {
			broadcast       : BROADCAST_SOCKET_PROD_CONFIG,
			sportx          : SPORTSX_CONFIG,
			backup_services : BACKUP_SERVICES_PROD_CONFIG
		}
	},
	prod: {
		FEED_API                  : "https://feed.rooter.io/graphql",
		BROADCAST_VIEWS           : "https://broadcast-prod-view-events.rooter.io/broadcastViewEvents",
		BASE_URL                  : "https://final.api.rooter.io/v3/",
		USER_API_URL              : "https://user.api.rooter.io/",
		APP_SECRET_KEY            : "280947ca35f58f88d517efba13e1a61501fd68a0822d48525e22d2215521e7bd",
		FIREBASE_CONFIG           : SCOREBOARD_SOCKET_CONFIG,
		FIREBASE_BROADCAST_CONFIG : BROADCAST_SOCKET_PROD_CONFIG,
		FIREBASE_WEB_CONFIG       : WEB_CONFIG,
		FIREBASE_SPORTSX_CONFIG   : SPORTSX_CONFIG,
		FIREBASE_BACKUP_CONFIG    : BACKUP_SERVICES_PROD_CONFIG,
		REDIRECT                  : "https://mobile.rooter.io",
		CONSUMER_FEED_URL         : "https://feed.rooter.io/",
		FEED_POPULATOR_URL        : "https://feed-populator.rooter.io/",
		APPOLLO_URL               : "https://feed.rooter.io/graphql",
		BROADCAST_URL             : "https://broadcast.api.rooter.io/data",
		BROADCAST_DNS             : "https://broadcast.api.rooter.io/",
		GROOT_URL                 : "https://groot.rooter.io/rooter/",
		GA_ID                     : "UA-105786949-14",
		SEARCH_URL                : "https://search.rooter.io/",
		firebase                  : {
			broadcast       : BROADCAST_SOCKET_PROD_CONFIG,
			sportx          : SPORTSX_CONFIG,
			backup_services : BACKUP_SERVICES_PROD_CONFIG
		}
	}
}[env];

export default config;
